import { render, staticRenderFns } from "./notificationDialog.vue?vue&type=template&id=00673120&"
import script from "./notificationDialog.vue?vue&type=script&lang=js&"
export * from "./notificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./notificationDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports